import {
  CellMeasurer,
} from 'react-virtualized';

import {
  displayJson,
} from '../../../../utils';
import CircularProgress from '../../../CircularProgress';

import ChatAlert from './ChatAlert';
import ChatAudioRecording from './ChatAudioRecording';
import ChatChange from './ChatChange';
import ChatForm from './ChatForm';
import ChatMessage from './ChatMessage';
import ChatPhoto from './ChatPhoto';
import ChatQuestion from './ChatQuestion';
import ChatQuestionnaireInteraction from './ChatQuestionnaireInteraction';
import ChatThanks from './ChatThanks';

const renderCaseMessage = (
  gthrId,
  groupsMap,
  imagesMap,
  selectGathering,
) => (
  translate,
  cache,
  messagesRef,
  participantsRef,
  myId,
  discussion,
  getMedia,
  audioAvailable,
  audioStartContext,
  audioContextRef,
  audioAnalyzerRef,
  createAlert,
  messageListRef,
) => function renderCaseMessageModel({
  index,
  isScrolling,
  isVisible,
  key,
  parent,
  style,
}) {
  const csid = discussion;

  const offsetIndex = ((messagesRef.current?.[0])
    ? (index - messagesRef.current[0].id + 1)
    : 0);

  const message = (gthrId && csid && messagesRef.current.length && (offsetIndex >= 0))
    ? messagesRef.current[offsetIndex]
    : undefined;

  if (!message) {
    return (
      <div className="h-10" style={style}>
        <CircularProgress />
      </div>

    // <CellMeasurer
    //   key={`pending_${key}`}
    //   cache={cache}
    //   parent={parent}
    //   columnIndex={0}
    //   rowIndex={index}
    // >
    //   {({ registerChild }) => (
    //     <div style={style} ref={registerChild}>
    //       <CircularProgress />
    //     </div>
    //   )}
    // </CellMeasurer>
    );
  }

  const {
    msgType,
    crUid, // Message author
    gthrId: msgGthrId,
  } = message;

  // Messages from other discussions render dimmed; clicking one switches to it.
  const visibleInThisGathering = (msgGthrId === gthrId);

  // console.log(`renderCaseMessage index=${index} crUid=${
  //   crUid}, myId=${myId} msg=${
  //   displayJson(message)}`);
  let name;
  let color;
  let gcatCode;
  let grpGpid;
  let grpLbl;
  let grpNbr;
  let initials;
  let crBlocked;
  let prtnrLogoUrl;

  if (crUid !== myId) {
    const thisParticipant = participantsRef.current[crUid];

    if (thisParticipant) {
      name = thisParticipant.name || '?';
      color = thisParticipant.color;
      gcatCode = thisParticipant.gcatCode;
      grpGpid = thisParticipant.grpGpid;
      grpLbl = thisParticipant.grpLbl;
      grpNbr = thisParticipant.grpNbr;
      initials = thisParticipant.initials;
      crBlocked = thisParticipant.crBlocked;
      prtnrLogoUrl = thisParticipant.prtnrLogoUrl;
    } else {
      name = '...';
      color = '#000000';
      // gcatCode = undefined;
      initials = '?';
    }
  }

  /* if (json) {
      const eventObject = JSON.parse(txt);
      let message;
      if (eventObject.type === 'init') message = `${name} a créé cette discussion.`;
      else if (eventObject.type === 'label') message = `${name} a renommé cette discussion.`;
      else message = `${name} - erreur`;

      returnObject = (
        <ChatEvent
          style={style}
          eventKey={id}
          dtime={ctime}
          message={message}
        />
      );
    } else { */

  const refreshCellSize = () => {
    if (cache.clear) {
      cache.clear(index);
    }
    messageListRef?.current?.recomputeRowHeights(index);
  };

  if (msgType === 'text') {
    return (
      <CellMeasurer key={key} cache={cache} parent={parent} columnIndex={0} rowIndex={index}>
        {({ registerChild }) => (
          <ChatMessage
            registerChild={registerChild}
            translate={translate}
            style={style}
            message={message}
            author={name}
            initials={initials}
            crBlocked={crBlocked}
            color={color}
            gcatCode={gcatCode}
            grpGpid={grpGpid}
            grpLbl={grpLbl}
            grpNbr={grpNbr}
            visibleInThisGathering={visibleInThisGathering}
            isScrolling={isScrolling}
            isVisible={isVisible}
            groupsMap={groupsMap}
            imagesMap={imagesMap}
            myCrUid={myId}
            selectGathering={selectGathering}
            prtnrLogoUrl={prtnrLogoUrl}
          />
        )}
      </CellMeasurer>
    );
  }

  if (msgType === 'change') {
    if (message.items) {
      // A committed questionnaire answer renders as the question pill plus the
      //  user's answer bubble; bare case changes stay with ChatChange.
      return (
        <CellMeasurer key={key} cache={cache} parent={parent} columnIndex={0} rowIndex={index}>
          {({ registerChild }) => (
            <ChatQuestionnaireInteraction
              registerChild={registerChild}
              translate={translate}
              style={style}
              message={message}
              author={name}
              initials={initials}
              crBlocked={crBlocked}
              color={color}
              gcatCode={gcatCode}
              grpGpid={grpGpid}
              grpLbl={grpLbl}
              grpNbr={grpNbr}
              visibleInThisGathering={visibleInThisGathering}
              groupsMap={groupsMap}
              imagesMap={imagesMap}
              prtnrLogoUrl={prtnrLogoUrl}
              selectGathering={selectGathering}
            />
          )}
        </CellMeasurer>
      );
    }

    return (
      <CellMeasurer key={key} cache={cache} parent={parent} columnIndex={0} rowIndex={index}>
        {({ registerChild }) => (
          <ChatChange
            registerChild={registerChild}
            translate={translate}
            style={style}
            message={message}
            author={name}
            initials={initials}
            crBlocked={crBlocked}
            color={color}
            gcatCode={gcatCode}
            visibleInThisGathering={visibleInThisGathering}
            participantsRef={participantsRef}
            grpGpid={grpGpid}
            grpLbl={grpLbl}
            grpNbr={grpNbr}
            groupsMap={groupsMap}
            imagesMap={imagesMap}
            myCrUid={myId}
            selectGathering={selectGathering}
            prtnrLogoUrl={prtnrLogoUrl}
          />
        )}
      </CellMeasurer>
    );
  }

  if (msgType === 'audioRec') {
    return (
      <CellMeasurer key={key} cache={cache} parent={parent} columnIndex={0} rowIndex={index}>
        {({ registerChild }) => (
          <ChatAudioRecording
            registerChild={registerChild}
            translate={translate}
            style={style}
            message={message}
            author={name}
            initials={initials}
            crBlocked={crBlocked}
            color={color}
            gcatCode={gcatCode}
            csid={csid}
            getMedia={getMedia}
            audioAvailable={audioAvailable}
            audioStartContext={audioStartContext}
            audioContextRef={audioContextRef}
            audioAnalyzerRef={audioAnalyzerRef}
            visibleInThisGathering={visibleInThisGathering}
            grpGpid={grpGpid}
            grpLbl={grpLbl}
            grpNbr={grpNbr}
            groupsMap={groupsMap}
            imagesMap={imagesMap}
            myCrUid={myId}
            selectGathering={selectGathering}
            prtnrLogoUrl={prtnrLogoUrl}
          />
        )}
      </CellMeasurer>
    );
  }

  if ((msgType === 'question') || (msgType === 'statement')) {
    return (
      <CellMeasurer key={key} cache={cache} parent={parent} columnIndex={0} rowIndex={index}>
        {({ registerChild }) => (
          <ChatQuestion
            registerChild={registerChild}
            translate={translate}
            style={style}
            message={message}
            author={name}
            initials={initials}
            crBlocked={crBlocked}
            color={color}
            gcatCode={gcatCode}
            visibleInThisGathering={visibleInThisGathering}
            grpGpid={grpGpid}
            grpLbl={grpLbl}
            grpNbr={grpNbr}
            groupsMap={groupsMap}
            imagesMap={imagesMap}
            myCrUid={myId}
            selectGathering={selectGathering}
            prtnrLogoUrl={prtnrLogoUrl}
          />
        )}
      </CellMeasurer>
    );
  }

  if (msgType === 'form') {
    return (
      <CellMeasurer key={key} cache={cache} parent={parent} columnIndex={0} rowIndex={index}>
        {({ registerChild }) => (
          <ChatForm
            registerChild={registerChild}
            translate={translate}
            style={style}
            message={message}
            author={name}
            initials={initials}
            crBlocked={crBlocked}
            color={color}
            gcatCode={gcatCode}
            getMedia={getMedia}
            csid={csid}
            createAlert={createAlert}
            visibleInThisGathering={visibleInThisGathering}
            isScrolling={isScrolling}
            isVisible={isVisible}
            grpGpid={grpGpid}
            grpLbl={grpLbl}
            grpNbr={grpNbr}
            groupsMap={groupsMap}
            imagesMap={imagesMap}
            myCrUid={myId}
            selectGathering={selectGathering}
            prtnrLogoUrl={prtnrLogoUrl}
          />
        )}
      </CellMeasurer>
    );
  }

  if (msgType === 'photo') {
    return (
      <CellMeasurer key={key} cache={cache} parent={parent} columnIndex={0} rowIndex={index}>
        {({ registerChild }) => (
          <ChatPhoto
            registerChild={registerChild}
            translate={translate}
            style={style}
            message={message}
            author={name}
            initials={initials}
            crBlocked={crBlocked}
            color={color}
            gcatCode={gcatCode}
            getMedia={getMedia}
            csid={csid}
            createAlert={createAlert}
            visibleInThisGathering={visibleInThisGathering}
            isScrolling={isScrolling}
            isVisible={isVisible}
            grpGpid={grpGpid}
            grpLbl={grpLbl}
            grpNbr={grpNbr}
            groupsMap={groupsMap}
            imagesMap={imagesMap}
            refreshCellSize={refreshCellSize}
            myCrUid={myId}
            selectGathering={selectGathering}
            prtnrLogoUrl={prtnrLogoUrl}
          />
        )}
      </CellMeasurer>
    );
  }

  if (msgType === 'alert') {
    return (
      <CellMeasurer key={key} cache={cache} parent={parent} columnIndex={0} rowIndex={index}>
        {({ registerChild }) => (
          <ChatAlert
            registerChild={registerChild}
            translate={translate}
            style={style}
            message={message}
            author={name}
            initials={initials}
            crBlocked={crBlocked}
            color={color}
            gcatCode={gcatCode}
            getMedia={getMedia}
            csid={csid}
            visibleInThisGathering={visibleInThisGathering}
            isScrolling={isScrolling}
            isVisible={isVisible}
            grpGpid={grpGpid}
            grpLbl={grpLbl}
            grpNbr={grpNbr}
            groupsMap={groupsMap}
            imagesMap={imagesMap}
            myCrUid={myId}
            selectGathering={selectGathering}
            prtnrLogoUrl={prtnrLogoUrl}
          />
        )}
      </CellMeasurer>
    );
  }

  if (msgType === 'thanks') {
    return (
      <CellMeasurer key={key} cache={cache} parent={parent} columnIndex={0} rowIndex={index}>
        {({ registerChild }) => (
          <ChatThanks
            registerChild={registerChild}
            translate={translate}
            style={style}
            message={message}
            author={name}
            initials={initials}
            crBlocked={crBlocked}
            color={color}
            gcatCode={gcatCode}
            visibleInThisGathering={visibleInThisGathering}
            isScrolling={isScrolling}
            isVisible={isVisible}
            grpGpid={grpGpid}
            grpLbl={grpLbl}
            grpNbr={grpNbr}
            groupsMap={groupsMap}
            imagesMap={imagesMap}
            myCrUid={myId}
            selectGathering={selectGathering}
            prtnrLogoUrl={prtnrLogoUrl}
          />
        )}
      </CellMeasurer>
    );
  }

  // Un-recognized message
  return (
    <CellMeasurer key={key} cache={cache} parent={parent} columnIndex={0} rowIndex={index}>
      {({ registerChild }) => (
        <ChatMessage
          registerChild={registerChild}
          translate={translate}
          style={style}
          message={{
            id: message.id,
            msgCdatim1: message.msgCdatim1,
            msgTxt: `msg=${displayJson(message)}`,
          }}
          author={name}
          initials={initials}
          crBlocked={crBlocked}
          color={color}
          gcatCode={gcatCode}
          visibleInThisGathering={visibleInThisGathering}
          isScrolling={isScrolling}
          isVisible={isVisible}
          grpGpid={grpGpid}
          grpLbl={grpLbl}
          grpNbr={grpNbr}
          groupsMap={groupsMap}
          imagesMap={imagesMap}
          myCrUid={myId}
          prtnrLogoUrl={prtnrLogoUrl}
        />
      )}
    </CellMeasurer>
  );
};

export default renderCaseMessage;
